class ColorUtils {
  constructor() {}
  formatColor(e, opti) {
    const color = this.toNum3(e);
    return `rgba(${color[0]},${color[1]},${color[2]},${opti})`;
  }
  isHex(color) {
    return color.length >= 4 && color[0] === '#';
  }

  isRgb(color) {
    return color.length >= 10 && color.slice(0, 3) === 'rgb';
  }

  isRgba(color) {
    return color.length >= 13 && color.slice(0, 4) === 'rgba';
  }

  pad2(num) {
    let t = num.toString(16);
    if (t.length === 1) t = '0' + t;
    return t;
  }

  lighten(colorStr, weight) {
    return this.mix('fff', colorStr, weight);
  }

  darken(colorStr, weight) {
    return this.mix('000', colorStr, weight);
  }

  mix(color1, color2, weight1, alpha1, alpha2) {
    color1 = this.dropPrefix(color1);
    color2 = this.dropPrefix(color2);
    if (weight1 === undefined) weight1 = 0.5;
    if (alpha1 === undefined) alpha1 = 1;
    if (alpha2 === undefined) alpha2 = 1;

    let w = 2 * weight1 - 1;
    let alphaDelta = alpha1 - alpha2;
    let w1 = ((w * alphaDelta === -1 ? w : (w + alphaDelta) / (1 + w * alphaDelta)) + 1) / 2;
    let w2 = 1 - w1;

    let rgb1 = this.toNum3(color1);
    let rgb2 = this.toNum3(color2);
    let r = Math.round(w1 * rgb1[0] + w2 * rgb2[0]);
    let g = Math.round(w1 * rgb1[1] + w2 * rgb2[1]);
    let b = Math.round(w1 * rgb1[2] + w2 * rgb2[2]);
    return '#' + this.pad2(r) + this.pad2(g) + this.pad2(b);
  }

  rgbaToRgb(colorStr, alpha, bgColorStr) {
    return this.mix(colorStr, bgColorStr || 'fff', 0.5, alpha, 1 - alpha);
  }

  toNum3(colorStr) {
    colorStr = this.dropPrefix(colorStr);
    if (colorStr.length === 3) {
      colorStr = colorStr[0] + colorStr[0] + colorStr[1] + colorStr[1] + colorStr[2] + colorStr[2];
    }
    let r = parseInt(colorStr.slice(0, 2), 16);
    let g = parseInt(colorStr.slice(2, 4), 16);
    let b = parseInt(colorStr.slice(4, 6), 16);
    return [r, g, b];
  }

  dropPrefix(colorStr) {
    return colorStr.replace('#', '');
  }

  rrggbbToHsl(rrggbb) {
    let rgb = this.toNum3(rrggbb);
    let hsl = this.rgbToHsl.apply(0, rgb);
    return [
      hsl[0].toFixed(0),
      (hsl[1] * 100).toFixed(3) + '%',
      (hsl[2] * 100).toFixed(3) + '%',
    ].join(',');
  }

  rgbToHsl(r, g, b) {
    let r_r = r / 255,
      r_g = g / 255,
      r_b = b / 255;

    let max = Math.max(r_r, r_g, r_b),
      min = Math.min(r_r, r_g, r_b);
    let delta = max - min,
      l = (max + min) / 2;
    let h = 0,
      s = 0;
    if (Math.abs(delta) > 0.00001) {
      if (l <= 0.5) s = delta / (max + min);
      else s = delta / (2 - max - min);
      let r_dist = (max - r_r) / delta,
        g_dist = (max - r_g) / delta,
        b_dist = (max - r_b) / delta;
      if (r_r == max) h = b_dist - g_dist;
      else if (r_g == max) h = 2 + r_dist - b_dist;
      else h = 4 + g_dist - r_dist;
      h = h * 60;
      if (h < 0) h += 360;
    }
    return [h, s, l];
  }
}

export default new ColorUtils();
